import { getIdFromUserPath } from '../../../containers/Users/helpers';
import createSelector from '../../../lib/createDeepEqualSelector';
import { State } from '../../../types/state';
import { getRoleName } from '../groups/helpers';

const groupsSelector = (state: State) => state.groups;
export const usersSelector = (state: State) => state.users.list;
const pathnameSelector = (state: State) => state.router.location.pathname;

export const selectedUserSelector = createSelector(
  usersSelector,
  pathnameSelector,
  groupsSelector,
  (users, pathname, groups) => {
    const userId = getIdFromUserPath(pathname);
    const user = users.find(({ id }) => id === userId);

    if (user && groups.length) {
      const role = getRoleName(user.groups, groups);
      return { ...user, role };
    }
    return undefined;
  }
);
